module.exports = __webpack_public_path__ + "@/assets/img/chevron-down.5009ac6d.svg";